import React from 'react';
import { Heading, Text, Box, Modal, ModalBody } from '@razorpay/blade/components';
import { getStaticMediaUrl } from 'utils/Urls';
import fileExecutionInProgress from 'assets/bulkUploads/file-execution-in-progress.svg';
import styled, { css, keyframes } from 'styled-components';

// Rotation animation
const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const LoaderContainer = styled.div`
  position: relative;
  width: 120px;
  height: 120px;
`;

const SpinnerArc = styled.div(
  ({ theme }) => css`
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: ${theme.border.radius.round};
    border: 6px solid transparent;
    border-top: 6px solid ${theme.colors.surface.border.primary.normal};
    animation: ${rotate} 1.2s linear infinite;
    box-sizing: border-box;
  `,
);

const BackgroundRing = styled.div(
  ({ theme }) => `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: ${theme.border.radius.round};
  border: 6px solid ${theme.colors.surface.border.gray.normal};
`,
);

const CenterImage = styled.img`
  width: auto;
  height: 70px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  object-fit: contain;
`;

export const ExecutionInProgressModal = ({ isOpen }: { isOpen: boolean }) => {
  return (
    <Modal isOpen={isOpen} onDismiss={() => {}} size="small">
      <ModalBody padding="spacing.0">
        <Box
          padding="spacing.7"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center">
          <Box marginBottom="spacing.5">
            <LoaderContainer>
              <BackgroundRing />
              <SpinnerArc />
              <CenterImage
                alt=""
                height="70px"
                width="auto"
                src={getStaticMediaUrl(fileExecutionInProgress)}
              />
            </LoaderContainer>
          </Box>
          <Heading
            size="small"
            weight="semibold"
            color="surface.text.gray.normal"
            textAlign="center">
            Processing your uploads
          </Heading>
          <Text
            size="medium"
            color="surface.text.gray.muted"
            textAlign="center"
            marginTop="spacing.3">
            This may take a while. Sit tight.
          </Text>
        </Box>
      </ModalBody>
    </Modal>
  );
};
